exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "tr.invalid .form-control {\n    border-color: red;\n}\n.container{\n    overflow-y: hidden;\n    overflow-x: hidden;\n}\n.header {\n    color: white;\n    background-color: #2d3349 !important;\n    margin-top: -24px !important;\n    margin-left: -39px !important;\n    margin-right: -39px !important;\n    /* position: fixed;\n    top: 0;\n    right: 0;\n    left: 0; */\n}\n::webkit-scrollbar { \n    display: none !important;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/shared/components/bulk-time-logs-dialog/bulk-time-logs-dialog.component.css
// module id = ../../../../../src/app/shared/components/bulk-time-logs-dialog/bulk-time-logs-dialog.component.css
// module chunks = main